export type FlightSearchProviderId = "secl" | "golibe";

export interface FlightSearchProvider {
  id: FlightSearchProviderId;
  label: string;
  src: string;
  useIframeResizer: boolean;
  fallbackHeight?: string;
}

export const FLIGHT_SEARCH_PROVIDERS: Record<
  FlightSearchProviderId,
  FlightSearchProvider
> = {
  secl: {
    id: "secl",
    // Self-hosted document that loads the SECL "Search Panel Plugin"
    // (jQuery/AngularJS). Same-origin, so X-Frame-Options does not apply and
    // the heavy Bootstrap/Angular globals stay sandboxed in the iframe.
    // See public/secl_search/index.html.
    label: "SECL",
    src: "/secl_search/index.html",
    useIframeResizer: true,
  },
  golibe: {
    id: "golibe",
    label: "Golibe",
    src: "/deal_search/index.html",
    useIframeResizer: true,
  },
};

const DEFAULT_PROVIDER: FlightSearchProviderId = "secl";

export function getActiveFlightSearchProvider(): FlightSearchProvider {
  const fromEnv = process.env.REACT_APP_FLIGHT_SEARCH_PROVIDER as
    | FlightSearchProviderId
    | undefined;

  const id =
    fromEnv && fromEnv in FLIGHT_SEARCH_PROVIDERS ? fromEnv : DEFAULT_PROVIDER;

  return FLIGHT_SEARCH_PROVIDERS[id];
}
